import { observer } from 'mobx-react'
import React from 'react'
import styles from './OCRScopeJobDetailBodyLegendInformation.sass'
import OCRScopingJobMainPanelViewModel from '../../OCRScopingJobMainPanelViewModel'
import OCRScopeJobDetailBodyTitle from '../OCRScopeJobDetailBodyTitle'
import Step from '../../../../../../creation/views/JobCreation/JobCreationFormView/Step'
import { BoolSelectEditorInput } from '../../../../../../questions/Bool/components/BoolEditorInput'
import TextEditorInput from '../../../../../../questions/Text/components/TextEditorInput'
import NumericEditorInput from '../../../../../../questions/Numeric/components/NumericEditorInput'
import DateTimeEditorInput from '../../../../../../questions/DateTime/components/DateTimeEditorInput'
import DocumentsEditorInput from '../../../../../../questions/Documents/components/DocumentsEditorInput'
import { AdvancedSelect } from '../../../../../../questions/Select/components/SelectEditorInput'
import BreakerEditorInput from '../../../../../../questions/Breaker/components/BreakerEditorInput'
import BoolQuestionViewModel from '../../../../../../questions/Bool/BoolQuestionViewModel'
import { QuestionStepViewModel } from '../../../../../../creation/IntakeQuestionsViewModel'
import TextQuestionViewModel from '../../../../../../questions/Text/TextQuestionViewModel'
import NumericQuestionViewModel from '../../../../../../questions/Numeric/NumericQuestionViewModel'
import DateTimeQuestionViewModel from '../../../../../../questions/DateTime/DateTimeQuestionViewModel'
import DocumentsQuestionViewModel from '../../../../../../questions/Documents/DocumentsQuestionViewModel'
import SelectQuestionViewModel from '../../../../../../questions/Select/SelectQuestionViewModel'

interface OCRScopeJobDetailsProps {
  vm: OCRScopingJobMainPanelViewModel
}
export default observer(function OCRScopeJobDetailBodyLegendInformation({
  vm,
}: OCRScopeJobDetailsProps) {
  const editor = vm.editor
  const questions = editor.intakeQuestions.stepContainers

  return (
    <div className={styles.root}>
      <OCRScopeJobDetailBodyTitle title={'Legend Information'} />

      <div className={styles.content}>
        {questions.map((questionContainer) => (
          <Step
            key={questionContainer.step.stepId}
            title={questionContainer.step.outlineDisplay.title}
            isLast={questionContainer.step.position.last}
            descriptionHtml={questionContainer.step.descriptionHtml}
            active={questionContainer.step.isActive}
            becomeActive$={questionContainer.step.becomeActive$}
            onBecomeVisible={questionContainer.step.becomeVisible}
            onBecomeHidden={questionContainer.step.becomeHidden}
            data-test={`step-${questionContainer.step.stepId}`}
            compact
          >
            {renderQuestion(questionContainer)}
          </Step>
        ))}
      </div>
    </div>
  )
})

/**
 * Each step container represents a piece of the creation UI and its' associated view model.
 *
 * @param stepContainer
 */
function renderQuestion(stepContainer: QuestionStepViewModel) {
  if (stepContainer.question instanceof BoolQuestionViewModel) {
    return (
      <BoolSelectEditorInput
        vm={stepContainer.question}
        disabled={stepContainer.disabled}
        focus$={stepContainer.step.becomeActive$}
        onFocus={stepContainer.step.onBecameActive}
      />
    )
  }

  if (stepContainer.question instanceof TextQuestionViewModel) {
    return (
      <TextEditorInput
        vm={stepContainer.question}
        disabled={stepContainer.disabled}
        focus$={stepContainer.step.becomeActive$}
        onFocus={stepContainer.step.onBecameActive}
      />
    )
  }

  if (stepContainer.question instanceof NumericQuestionViewModel) {
    return (
      <NumericEditorInput
        vm={stepContainer.question}
        disabled={stepContainer.disabled}
        focus$={stepContainer.step.becomeActive$}
        onFocus={stepContainer.step.onBecameActive}
      />
    )
  }

  if (stepContainer.question instanceof DateTimeQuestionViewModel) {
    return (
      <DateTimeEditorInput
        vm={stepContainer.question}
        disabled={stepContainer.disabled}
        focus$={stepContainer.step.becomeActive$}
        onFocus={stepContainer.step.onBecameActive}
      />
    )
  }

  if (stepContainer.question instanceof DocumentsQuestionViewModel) {
    return (
      <DocumentsEditorInput
        vm={stepContainer.question}
        disabled={stepContainer.disabled}
        focus$={stepContainer.step.becomeActive$}
        onFocus={stepContainer.step.onBecameActive}
      />
    )
  }

  if (stepContainer.question instanceof SelectQuestionViewModel) {
    return (
      <AdvancedSelect
        vm={stepContainer.question}
        disabled={stepContainer.disabled}
        focus$={stepContainer.step.becomeActive$}
        onFocus={stepContainer.step.onBecameActive}
      />
    )
  }

  return (
    <BreakerEditorInput
      vm={stepContainer.question}
      disabled={stepContainer.disabled}
      focus$={stepContainer.step.becomeActive$}
      onFocus={stepContainer.step.onBecameActive}
    />
  )
}
